"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";

export const RedirectPage = () => {
  const router = useRouter();

  useEffect(() => {
    router.push("https://login.inter-nation.uz/?role=staff");
  }, [router]);

  return (
    <div>
      <p>Loading...</p>
    </div>
  );
};
